module.exports = __webpack_public_path__ + "static/media/tutorial.401d63ae.svg";